'use client';

import type { ReactNode } from 'react';
import type { StreamingContentProps } from '../../tool-config-types';
import { ToolCallProgressLogPanel } from '../ToolCallProgressLogPanel';

export const renderTraceInvestigationStreamingContent = (
  props: StreamingContentProps,
): ReactNode => (
  <ToolCallProgressLogPanel
    progressEvents={props.progressEvents}
    isRunning={props.isRunning}
  />
);
